/* eslint-disable @typescript-eslint/ban-ts-comment */
import $ from 'jquery'
// @ts-ignore
window.jQuery = $
// @ts-ignore
window.$ = $
